<template>
  <div>
    <div 
      style="cursor: pointer;" 
      class="card-dashboard card-dashboard-ativo w3-theme" 
      @click="abrirModalXmlEntradasDias(cinco_dias, '5')">
      
      <div class="card-dashboard-inner">
        <span class="icone-card">
          <i class="far fa-calendar-alt"></i>
        </span>

        <span class="card-dashboard-titulo card-clicavel-titulo">
          <span>XML liberados para entrada</span>
        </span>

        <div class="w3-right-center">
          <span class="card-dashboard-dado">5 dias</span>
        </div>
        
        <div class="w3-right-align">
          <span class="card-dashboard-dado">
            {{cinco_dias.length}}
          </span>
        </div>   
        
        <div class="w3-clear"></div>
      </div>
    </div>

    <div 
      style="cursor: pointer;"
      class="card-dashboard card-dashboard-ativo w3-theme"
      @click="abrirModalXmlEntradasDias(dez_dias, '10')">
      
      <div class="card-dashboard-inner">
        <span class="icone-card">
          <i class="far fa-calendar-alt"></i>
        </span>

        <span class="card-dashboard-titulo card-clicavel-titulo">
          <span>XML liberados para entrada</span>
        </span>

        <div class="w3-right-center">
          <span class="card-dashboard-dado">10 dias</span>
        </div>
        
        <div class="w3-right-align">
          <span class="card-dashboard-dado">{{dez_dias.length}}</span>
        </div>   
        
        <div class="w3-clear"></div>
      </div>
    </div>

    <div 
      style="cursor: pointer;" 
      class="card-dashboard card-dashboard-ativo w3-theme"
      @click="abrirModalXmlEntradasDias(vinte_dias_mais, '20+')">
      
      <div class="card-dashboard-inner">
        <span class="icone-card">
          <i class="far fa-calendar-alt"></i>
        </span>

        <span class="card-dashboard-titulo card-clicavel-titulo">
          <span>XML liberados para entrada</span>
        </span>

        <div class="w3-right-center">
          <span class="card-dashboard-dado">20+ dias</span>
        </div>
        
        <div class="w3-right-align">
          <span class="card-dashboard-dado">{{vinte_dias_mais.length}}</span>
        </div>   
        
        <div class="w3-clear"></div>
      </div>
    </div>
    
    <div 
      style="cursor: pointer;"
      class="card-dashboard card-dashboard-ativo w3-theme"
      @click="abrirModalXmlEntradasDias(criticas_cadastro, 'de cadastro')">
      
      <div class="card-dashboard-inner">
        <span class="icone-card">
          <i class="fas fa-align-right"></i>
        </span>

        <span class="card-dashboard-titulo card-clicavel-titulo">
          <span>Entradas com críticas de cadastro</span>
        </span>
        
        <div class="w3-right-align">
          <span class="card-dashboard-dado">{{criticas_cadastro.length}}</span>
        </div>
        
        <div class="w3-clear"></div>
      </div>
    </div>
  
    <div 
      style="cursor: pointer;"
      class="card-dashboard card-dashboard-ativo w3-theme"
      @click="abrirModalXmlEntradasDias(criticas_fiscais, 'fiscais')">
      
      <div class="card-dashboard-inner">
        <span class="icone-card">
          <i class="fas fa-align-justify"></i>
        </span>

        <span class="card-dashboard-titulo card-clicavel-titulo">
          <span>Entradas com críticas fiscal</span>
        </span>

        <div class="w3-right-align">
          <span class="card-dashboard-dado">{{criticas_fiscais.length}}</span>
        </div>

        <div class="w3-clear"></div>
      </div>
    </div>
    
    <div 
      style="cursor: pointer;" 
      class="card-dashboard card-dashboard-ativo w3-theme" 
      @click="abrirModalXmlEntradasDias(criticas_negociacao, 'de negociação')">
      <div class="card-dashboard-inner">
        <span class="icone-card">
          <i class="fas fa-align-left"></i>
        </span>

        <span class="card-dashboard-titulo card-clicavel-titulo">
          <span>Entradas com críticas de negociação</span>
        </span>

        <div class="w3-right-align">
          <span class="card-dashboard-dado">{{criticas_negociacao.length}}</span>
        </div>

        <div class="w3-clear"></div>
      </div>
    </div>

  </div>
</template>

<script>
  import ComponenteCard from '@/components/ComponenteCard'
  import RAnaliseAutomaticaXMLEntrada from '@/components/Rest/RAnaliseAutomaticaXMLEntrada.js'
  import moment from 'moment'
  import toastr from 'toastr'

  export default {
    name: 'AnaliseDeXml',

    components: {
      ComponenteCard,
    },

    data() {
      return {
        dez_dias: [],
        cinco_dias: [],
        vinte_dias_mais: [],
        criticas_fiscais: [],
        criticas_cadastro: [],
        criticas_negociacao: []
      }
    },

    mounted() {
      $('html,body').stop().animate(
        {scrollTop: 0}, 
        'slow', 
        'swing'
      );
    },

    methods: {
      abrirModalXmlEntradasDias(lista = [], dias){
        if (lista.length < 1) {
          toastr.error('Nenhum dado foi encontrado!');
        } 
        else {
          this.$emit('abrirModalXmlEntradasDias', lista, dias);
        }
      },

      async buscarXml() { 
        this.processando = true;

        try {        
          let retorno = await RAnaliseAutomaticaXMLEntrada.buscarXMLPendentes(this.axios);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          let horaAnalise = moment()
          for (let i = 0; i < retorno.dados.analises.length; i++) {
            horaAnalise = Date.parse(moment(retorno.dados.analises[i].data_hora_analise, 'DD/MM/YYYY'));    

            if (retorno.dados.analises[i].status_analise == 'LIB') {
              this.vinte_dias_mais.push(retorno.dados.analises[i]);
            }

            if (moment().subtract(5, 'days').isBefore(horaAnalise) && retorno.dados.analises[i].status_analise == 'LIB'){
              this.cinco_dias.push(retorno.dados.analises[i]);
            }

            if (moment().subtract(10, 'days').isBefore(horaAnalise) && retorno.dados.analises[i].status_analise == 'LIB') {
              this.dez_dias.push(retorno.dados.analises[i]);
            }

            if (retorno.dados.analises[i].criticas_cadastro === 'S') {
              this.criticas_cadastro.push(retorno.dados.analises[i]);
            }

            if (retorno.dados.analises[i].criticas_fiscal === 'S') {
              this.criticas_fiscais.push(retorno.dados.analises[i]);
            }

            if (retorno.dados.analises[i].criticas_negociacao === 'S') {
              this.criticas_negociacao.push(retorno.dados.analises[i]);
            }
          }
        } 
        catch (error) {
          this.processando = false;
          toastr.error(error.message);
        }
      }
    },

    created() {
      this.buscarXml();
    }
  }
</script>

<style scoped>
  .card-informacoes {
    margin-bottom: 10px;
    border-left-style: solid;
    border-left-color: #636363 !important;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    float: left;
    padding: 7px;
    border-bottom-color: #636363 !important;
  }

  .card-dashboard {
    border-radius: 10px;
    float: left;
    width: calc((100% / 4) - 15px);
    margin: 0 auto;
    background-color: #e6e6e6;
    padding: 20px;
    margin-right: 15px;
    margin-bottom: 15px;
    position: relative;
    display: table;
    text-align: center;
  }

  .card-dashboard-escondido {
    display: none !important;
  }

  .card-clicavel-titulo {
    text-decoration: underline
  }

  .card-dashboard.card-dashboard-ativo .w3-display-topright i, 
  .card-dashboard.card-dashboard-ativo .card-dashboard-titulo, 
  .card-dashboard.card-dashboard-ativo .card-dashboard-dado {
    color: white !important
  }

  .card-dashboard.card-dashboard-ativo .card-dashboard-inner .icone-card {
    color: white;
    border: 2px solid white;
  }

  .card-dashboard .card-dashboard-inner {
    display: table-cell;
    position: relative;
    height: 205px;
    padding-top: 10px;
  }

  .card-dashboard .card-dashboard-inner .icone-card {
    color: #9c1d1c;
    display: inline-block;
    border-radius: 50%;
    width: 80px; 
    height: 80px;
    border: 2px solid #9c1d1c;
    margin-bottom: 15px;
    line-height: 80px;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 3em;
  }

  .card-dashboard .card-dashboard-inner .w3-right-align {
    position: absolute;
    right: 0;
    bottom: 0;
  }

  @media(max-width: 1700px) {
    .card-dashboard {
      width: calc((100%/3) - 15px)
    }
  }

  @media(max-width: 1366px) {
    .container-cards {
      padding: 0 10% !important;
    }
  }

  @media(max-width: 1085px) {
    .card-dashboard {
      width: calc((100%/3) - 15px)
    }
  }

  @media(max-width: 845px) {
    .card-dashboard {
      width: calc((100%/2) - 15px)
    }
  }

  @media(max-width: 645px) {
    .card-dashboard {
      width: 100%;
      margin-right: 0 !important;
      text-align: center;
    }

    .container-cards {
      padding: 0 !important;
    }

    .card-dashboard .w3-right-align {
      text-align: center !important;
      min-width: 235px !important
    }
  }

  .card-dashboard-titulo {
    font-size: 1.2em;
    color: #666;
    width: 100%;
    display: block;
    text-align: center;
  }

  .card-dashboard-dado {
    font-size: 1.5em;
    font-weight: bold;
    color: #9c1d1c;
  }

  .card-dashboard-dado.reduzido {
    font-size: 1.4em !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/AnaliseDeXml.vue